import React, { Component } from "react";
import styled from "styled-components";
import { Consumer } from "../context/InfoContext";
import Row from "../dev/Row";
import Span from "../dev/Span";
import RecentBarChart from "./Recent/RecentBarChart";
import { EyeWhite } from "./Recent/Eye";
import { EngageWhite } from "./Recent/Engage";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Guide from "../dev/Guide";

const HighLow = props => {
    return (
        <a
            href={"https://www.youtube.com/watch?v=" + props.data.videoId}
            target="blank"
        >
            <HighLowContainer image={props.data.cover}>
                <HighLowContent>
                    <Span>{props.title}</Span>
                    <DeleteOhYeah>{props.data.title}</DeleteOhYeah>
                    <Row>
                        <EyeWrap>
                            <EyeWhite />
                            <Span>{props.data.viewCount}</Span>
                        </EyeWrap>
                        <Row item="center" width="auto">
                            <EngageWhite />
                            <Span>{props.data.engageRate}%</Span>
                        </Row>
                    </Row>
                </HighLowContent>
            </HighLowContainer>
        </a>
    );
};
class Recent extends Component {
    state = {
        info: {},
        infoId: -1,
        DataType:
            "近二十支影片" /*選擇哪個數據的圖表 訂閱數/觀看數/訂閱數成長率/平均互動率/日觀看成長率*/
    };
    // componentDidMount() {
    //     const { infoId } = this.props.match.params;
    //     const { REACT_APP_URI = "/" } = process.env;
    //     fetch(`${REACT_APP_URI}/Info/${infoId}`, {
    //         credentials: "include"
    //     }).then(res => {
    //         if (res.ok) return res.json();
    //         else throw res;
    //     })
    //     .then(Info => this.setState({ info: Info, infoId: Info.pk }));
    // }
    render() {
        const {
            user: { plan },
            messages
        } = this.props;
        const { DataType } = this.state;
        return (
            <Consumer>
                {value => {
                    const { isBlur } = value
                    if (
                        value.recentVideos === undefined ||
                        value.recentVideos.length === 0
                    ) {
                        //如果連最近二十支都沒，表示兩個月也沒，所以在這直接跳脫，原本的寫法只能擋權限不足，在沒有影片的狀況還是會爆掉
                        return (
                            <RecentDefault>
                                <Row padding="24px" borderbottom>
                                    <Row>
                                        <Span spanTitle>
                                            {messages.info_recent}
                                        </Span>
                                        <Guide
                                            list={[
                                                [`${messages['20_avg_views']} ${messages.dataDesc_equal}`,{numerator: messages.dataDesc_recentAvgViewCount_2, denominator: 20}, messages.dataDesc_recentAvgViewCount_3],
                                                [`${messages['20_avg_engage']} ${messages.dataDesc_equal}`,{numerator: messages.dataDesc_recentAvgEngageRate_2, denominator: messages.dataDesc_recentAvgEngageRate_3}, messages.dataDesc_recentAvgEngageRate_4],
                                                [`${messages.dataDesc_recentTwoMonthAvgViewCount} ${messages.dataDesc_equal}`,{numerator: messages.dataDesc_recentTwoMonthAvgViewCount_2, denominator: messages.dataDesc_recentTwoMonthAvgViewCount_3}, messages.dataDesc_recentTwoMonthAvgViewCount_4],
                                                [`${messages.dataDesc_recentTwoMonthAvgEngageRate} ${messages.dataDesc_equal}`,{numerator: messages.dataDesc_recentTwoMonthAvgEngageRate_2, denominator: messages.dataDesc_recentTwoMonthAvgEngageRate_3}, messages.dataDesc_recentTwoMonthAvgEngageRate_4],
                                            ]}
                                        />
                                    </Row>
                                </Row>
                                <Row padding=" 24px 24px 20px">
                                    <Category
                                        content="近二十支影片"
                                        nowstate={this.state.DataType}
                                        onClick={() => {
                                            this.setState({
                                                DataType: "近二十支影片"
                                            });
                                        }}
                                    >
                                        {messages.info_20}
                                    </Category>
                                    <Category
                                        content="近兩個月影片"
                                        nowstate={this.state.DataType}
                                        onClick={() => {
                                            this.setState({
                                                DataType: "近兩個月影片"
                                            });
                                        }}
                                    >
                                        {messages.info_2month}
                                    </Category>
                                    {(plan === "Agency" ||
                                        plan === "Brand") && (
                                        <div>
                                            {messages.info_data_collecting}
                                        </div>
                                    )}{" "}
                                    {/*有權限的人才看得到提示*/}
                                </Row>
                            </RecentDefault>
                        );
                    } //把原本那一行註解就會大爆炸＝＝ 所以才把下面的 dom 複製上來
                    const {
                        recentAvgViewCount,
                        recentAvgEngageRate,
                        recentViewHighest,
                        recentEngageRateHighest,
                        recentViewLowest,
                        recentEngageRateLowest,
                        twoMonthAvgViewCount,
                        twoMonthAvgEngageRate,
                        twoMonthViewHighest,
                        twoMonthEngageRateHighest,
                        twoMonthViewLowest,
                        twoMonthEngageRateLowest,
                        twoMonthVideos
                    } = value;
                    return (
                        <RecentDefault id="user_tour_info_4">
                            <Row padding="24px" borderbottom>
                                <Row>
                                    <Span spanTitle>
                                        {messages.info_recent}
                                    </Span>
                                    <Guide
                                        list={[
                                            [`${messages['20_avg_views']} ${messages.dataDesc_equal}`,{numerator: messages.dataDesc_recentAvgViewCount_2, denominator: 20}, messages.dataDesc_recentAvgViewCount_3],
                                            [`${messages['20_avg_engage']} ${messages.dataDesc_equal}`,{numerator: messages.dataDesc_recentAvgEngageRate_2, denominator: messages.dataDesc_recentAvgEngageRate_3}, messages.dataDesc_recentAvgEngageRate_4],
                                            [`${messages.dataDesc_recentTwoMonthAvgViewCount} ${messages.dataDesc_equal}`,{numerator: messages.dataDesc_recentTwoMonthAvgViewCount_2, denominator: messages.dataDesc_recentTwoMonthAvgViewCount_3}, messages.dataDesc_recentTwoMonthAvgViewCount_4],
                                            [`${messages.dataDesc_recentTwoMonthAvgEngageRate} ${messages.dataDesc_equal}`,{numerator: messages.dataDesc_recentTwoMonthAvgEngageRate_2, denominator: messages.dataDesc_recentTwoMonthAvgEngageRate_3}, messages.dataDesc_recentTwoMonthAvgEngageRate_4],
                                        ]}
                                    />
                                </Row>
                            </Row>
                            <Row  padding=" 24px 24px 20px" content='space-between'>
                                <Row width='auto'>
                                    <Category
                                        content="近二十支影片"
                                        nowstate={this.state.DataType}
                                        onClick={() => {
                                            this.setState({
                                                DataType: "近二十支影片"
                                            });
                                        }}
                                    >
                                        {messages.info_20}
                                    </Category>
                                    <Category
                                        content="近兩個月影片"
                                        nowstate={this.state.DataType}
                                        onClick={() => {
                                            this.setState({
                                                DataType: "近兩個月影片"
                                            });
                                        }}
                                    >
                                        {messages.info_2month}
                                    </Category>
                                    {twoMonthVideos.length === 0 &&
                                        DataType === "近兩個月影片" && (
                                            <div>
                                                {messages.info_data_collecting}
                                            </div>
                                        )}
                                </Row>
                                <Row width='auto'>
                                    {messages.info_video_everyweek_1}
                                    <Row width='auto' isBlur={value.isBlur} padding='0 .2rem'>{` ${value.weeklyPublishedVideos} `}</Row>
                                    {messages.info_video_everyweek_2}
                                </Row>
                            </Row>
                            {!(
                                twoMonthVideos.length === 0 &&
                                DataType === "近兩個月影片"
                            ) && ( //因為想要做如果沒有兩個月影片資料就顯示「資料蒐集中」的功能，因此在該情況下不產生下列內容，不然會爆掉
                                <div>
                                    <HighLowWrap isBlur={value.isBlur}>
                                        <HighLow
                                            data={
                                                DataType === "近二十支影片"
                                                    ? recentViewHighest
                                                    : twoMonthViewHighest
                                            }
                                            title={messages.info_20_high_views}
                                        />
                                        <HighLow
                                            data={
                                                DataType === "近二十支影片"
                                                    ? recentViewLowest
                                                    : twoMonthViewLowest
                                            }
                                            title={messages.info_20_low_views}
                                        />
                                        <HighLow
                                            data={
                                                DataType === "近二十支影片"
                                                    ? recentEngageRateHighest
                                                    : twoMonthEngageRateHighest
                                            }
                                            title={messages.info_20_high_engage}
                                        />
                                        <HighLow
                                            data={
                                                DataType === "近二十支影片"
                                                    ? recentEngageRateLowest
                                                    : twoMonthEngageRateLowest
                                            }
                                            title={messages.info_20_low_engage}
                                        />
                                    </HighLowWrap>
                                    <Average>
                                        <Row borderbottom height="100px" position={'relative'} zIndex={2}>
                                            <Row
                                                borderright
                                                content="center"
                                                item="center"
                                                width="22%"
                                            >
                                                <AverageSpan>
                                                    <Span isBlur={isBlur}>
                                                        {DataType ===
                                                        "近二十支影片"
                                                            ? recentAvgViewCount
                                                            : twoMonthAvgViewCount}
                                                    </Span>
                                                    <div>
                                                        <div />{" "}
                                                        {/*這邊塞一個假的是因為避免下面那個元件被AverageSpan選到變紅色*/}
                                                        <Span>
                                                            {
                                                                messages.info_20_avg_views
                                                            }{" "}
                                                        </Span>
                                                        {DataType ===
                                                            "近兩個月影片" && (
                                                            <Span>
                                                                (
                                                                {
                                                                    twoMonthVideos.length
                                                                }{" "}
                                                                {
                                                                    messages.info_video_count
                                                                }
                                                                )
                                                            </Span>
                                                        )}
                                                    </div>
                                                    {DataType ===
                                                        "近兩個月影片" &&
                                                        twoMonthVideos.length ===
                                                            240 && (
                                                            <Span>
                                                                {
                                                                    messages.info_2month_most_video
                                                                }
                                                            </Span>
                                                        )}
                                                </AverageSpan>
                                            </Row>
                                            <Row
                                                content="center"
                                                item="center"
                                                width="78%"
                                                isBlur={value.isBlur}
                                            >
                                                <RecentBarChartWrap>
                                                    <RecentBarChart
                                                        dataType={DataType}
                                                        dataKey="viewCount"
                                                        ticks={[
                                                            DataType ===
                                                            "近二十支影片"
                                                                ? recentAvgViewCount
                                                                : twoMonthAvgViewCount
                                                        ]}
                                                        maxData={
                                                            recentViewHighest.viewCount
                                                        }
                                                    />
                                                </RecentBarChartWrap>
                                            </Row>
                                        </Row>
                                        <Row height="100px">
                                            <Row
                                                borderright
                                                content="center"
                                                item="center"
                                                width="22%"
                                            >
                                                <AverageSpan>
                                                    <Span isBlur={isBlur}>
                                                        {DataType ===
                                                        "近二十支影片"
                                                            ? recentAvgEngageRate
                                                            : twoMonthAvgEngageRate}
                                                        %
                                                    </Span>
                                                    <Span>
                                                        {
                                                            messages.info_20_avg_engage
                                                        }
                                                    </Span>
                                                </AverageSpan>
                                            </Row>
                                            <Row
                                                content="center"
                                                item="center"
                                                width="78%"
                                                isBlur={value.isBlur}
                                            >
                                                <RecentBarChartWrap>
                                                    <RecentBarChart
                                                        dataType={DataType}
                                                        dataKey="engageRate"
                                                        ticks={[
                                                            DataType ===
                                                            "近二十支影片"
                                                                ? recentAvgEngageRate
                                                                : twoMonthAvgEngageRate
                                                        ]}
                                                        maxData={
                                                            recentEngageRateHighest.engageRate
                                                        }
                                                    />
                                                </RecentBarChartWrap>
                                            </Row>
                                        </Row>
                                    </Average>
                                </div>
                            )}
                        </RecentDefault>
                    );
                }}
            </Consumer>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.User,
        messages: state.Messages
    };
};
export default withRouter(connect(mapStateToProps)(Recent));

const RecentDefault = styled.div`
    position: relative;
    z-index: 1;
    grid-area: recent;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    height: auto;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);
    .recharts-cartesian-axis-tick-value {
        font-size: 0.6rem;
        fill: #787878;
    }
    .recharts-cartesian-grid-horizontal {
        line:nth-child(n + 2) {
            display: none;
        }
    }
    .recharts-rectangle {
        &:hover {
            fill: #de0606;
        }
    }
`;
const DeleteOhYeah = styled.div`
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    max-height: 2rem;
    color: #ffffff;
    font-size: 0.6rem;
    transition: all 0.3s ease;
`;
const HighLowWrap = styled.div`
    display: grid;
    grid-template-columns: repeat(4, calc(25% - 0.75px));
    grid-auto-flow: column;
    grid-column-gap: 1px;
    width: 860px;
    ${({ isBlur }) => isBlur ? 'filter: blur(3px)' : ''};
`;
const HighLowContainer = styled.div`
    height: 140px;
    /* debug */
    background: url(${props => props.image});
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    color: white;
`;
const HighLowContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    padding: 14px 24px;
    background-color: rgba(0, 0, 0, 0.7);
    transition: all 0.3s ease;
    &:hover {
        background-color: rgba(120, 120, 120, 0.3);
        span,
        ${DeleteOhYeah}, ${EyeWhite}, ${EngageWhite} {
            opacity: 0.3;
        }
    }
    span {
        color: #ffffff;
        font-size: 0.6rem;
        transition: all 0.3s ease;
    }
    span:nth-child(1) {
        font-size: 0.8rem;
        /* margin-bottom: 5px; */
    }
`;

const EyeWrap = styled.div`
    display: flex;
    align-items: center;
    min-width: 50%;
    margin-right: 10px;
`;

//Average
const Average = styled.div`
    position: relative;
    z-index: 1;
`;
const AverageSpan = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    span:nth-child(1) {
        font-size: 1.2rem;
        font-weight: 500;
        color: #de0606;
    }
    span:nth-child(2) {
        font-size: 0.6rem;
        font-weight: 300;
        color: #787878;
    }
`;
const RecentBarChartWrap = styled.div`
    height: 100%;
    width: 100%;
    padding-top: 20px;
`;
const Category = styled.div`
    display: inline-flex;
    height: 24px;
    padding: 0 8px;
    margin-right: 5px;
    margin-bottom: 5px;
    border-radius: 24px;
    border: ${props =>
        props.content === props.nowstate
            ? "solid 0.5px transparent"
            : "solid 0.5px #979797"};
    background-color: ${props =>
        props.content === props.nowstate ? "rgba(222, 6, 6, 0.5)" : "#fff"};
    font-size: 14px;
    font-weight: 300;
    color: ${props => (props.content === props.nowstate ? "#fff" : "#979797")};
    cursor: pointer;    
`;



// WEBPACK FOOTER //
// ./src/Info/Recent.js